import React, { useEffect, useState } from "react";
import Card from "antd/es/card/Card";
import { Col, Row, Image, Popover, Spin, Tooltip, Checkbox, message } from "antd";
import Title from "antd/es/typography/Title";
import { Typography } from "antd";
import styles from "./CollectionsCard.module.css";
import SaveIcon from '../../Icons/save.png'
import SaveIconFilled from '../../Icons/savefilled.png'
import ViewIcon from '../../Icons/view.png'
import parse from 'html-react-parser';

import {
  CaretDownOutlined,
  CaretUpOutlined,
  CloseCircleOutlined,
  DislikeFilled,
  DislikeOutlined,
  LikeFilled,
  LikeOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import TriggerMenu from "../CardMenu/CardMenu";
import BadgeIcon from "../BadgeIcon/BadgeIcon";
import CardModal from "../CardModal/CardModal";
import { useDispatch, useSelector } from "react-redux";
import { sendData } from "../../Slices/ModalSlice";
import Paragraph from "antd/es/typography/Paragraph";
import {
  fetchPublicItems, refreshCard, removeBookmarkLocal, removeDislike, removeLike, setLastBookmark, updateBookmarkLocal,
} from "../../Slices/PublicCollectionsDataSlice";
import { upload } from "@testing-library/user-event/dist/upload";
import UserActions, { addBookmark, handleDislike, handleLike, setUserInteractionProcessing, } from "../../Slices/UserActions";
import LoginModal from "../LoginModal/LoginModal";
// import Link from "antd/es/typography/Link";
import { setAdditionalKeys } from "../../Slices/PublicPageDataSlice";
import { Link, useNavigate } from "react-router-dom";
import { setWindowNHQ } from "../../Slices/WindowNHQSlice";
// import { refreshAuthorCollections } from "../../Slices/AuthorCollectionsSlice";
const { Text } = Typography;

const CollectionsCard = (props: any) => {
  const {isLogin, userInteractionProcessing } = useSelector((state:any) => state.userActions)
  const {collections, likedCollections, dislikedCollections, userBookmarks} = useSelector((state:any)=> state.publicCollectionsData)
  const [openBookmark, setOpenBookmark] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(false);
  const [loginModal, setLoginModal] = useState(false);
  const dispatch: any = useDispatch()
  const navigate = useNavigate();

  const currentUrl = window.location.href;

  const {
    id,
    title,
    loading,
    creator,
    profilepic,
    tags,
    likes,
    dislikes,
    uploadDate,
    description,
    url,
    liked,
    disliked,
    bookmarked,
    votes,
    username,
    slug,
    authorId
  } = props;

  
  const [like, setLike] = useState<any>(liked);
  const [dislike, setDislike] = useState<any>(disliked);
  const [isBookmark, setIsBookmark] = useState<any>();

    useEffect(()=>{
      setLike(liked);
      setDislike(disliked);
    }, [likes, dislikes, liked, disliked])
    
    useEffect(()=>{
      if(Array.isArray(bookmarked)){
        if(bookmarked.includes('B') &&  bookmarked.includes('F')){
          setIsBookmark(['B','F'])
        }
        else if (bookmarked.includes('B') && !bookmarked.includes('F')){
          setIsBookmark(['B'])
        }
        else if (!bookmarked.includes('B') && bookmarked.includes('F')){
          setIsBookmark(['F'])
        }
      }
      else{
        setIsBookmark([])
      }
    }, [bookmarked])

  const handleBookmark =()=>{
    isLogin &&
    setOpenBookmark(true)
  }

  const handlelogin = ()=>{
  setOpenDropdown(false);
  setLoginModal(true);
  dispatch(setWindowNHQ({id: id, type : 'collection', slug : slug}));
  }

  const onLoginCancel = ()=>{
    setLoginModal(false);
  }
  const loader = useSelector(
    (state: any) => state.publicCollectionsData.publicItemsLoader
  );
  const antIcon = (
    <LoadingOutlined className={styles.customLoader}  spin />
  );

  const dateOnly = uploadDate ? uploadDate : "N/A";

  const [open, setOpen] = useState(false);
  const sliceItem = useSelector(
    (state: any) => state.publicCollectionsData.items
  );
  const sliceItemId = !sliceItem ? "" : sliceItem.id;


  const handlePopoverOutsideClick = (visible:any) => {
    isLogin && setOpenBookmark(visible)
  };

  const handleDropdownOutsideClick = (newVisible:any) => {
   setOpenDropdown(newVisible)
  };

  const popoverTitle = (
    <Col style={{ display: "flex", justifyContent: "center", cursor: "pointer"}}>
      <Image
      onClick={()=> { dispatch(setWindowNHQ({id : authorId, type : "author", slug : username})) ; navigate(`/author/${username}`)}}
        width={80}
        preview={false}
        style={{
          objectFit: "cover",
          height: "80px",
          width: "80px",
          borderRadius: "50%",
          display: "inline-block",
        }}
        src={profilepic}
      ></Image>
    </Col>
  );

  const saveOptions = [
    { label: 'Bookmark', value: 'B' },
    { label: 'Favorites', value: 'F' },
  ];

  const handleSave = (checkedValues:any) => {
    dispatch(setUserInteractionProcessing(true))
    dispatch(addBookmark({id: id, type: checkedValues}))


    if (checkedValues.length === 0){
      dispatch(removeBookmarkLocal(id))
    }
    else {
    dispatch(updateBookmarkLocal({id, checkedValues}))
    }
    // checkedValues.length === 0 ? setIsBookmark(false) : setIsBookmark(true)
    dispatch(refreshCard())
    dispatch(setAdditionalKeys())
  };

  const saveContent = (
    <Col span={24}>
      <Checkbox.Group style={{display: "flex", flexDirection: "column"}} value={isBookmark} defaultValue={isBookmark} options={saveOptions} onChange={handleSave}  />
    </Col>
  )

  const content = (
    <Col>
     
      <div style={{display: "flex", flexDirection: "column"}}>
        {/* <Text className="textbold">Username: </Text> */}
        <Text className="textbold" style={{ textTransform: "capitalize", fontSize: "16px" }}>{creator}</Text>
        <Link style={{fontSize: "13px"}} onClick={()=> dispatch(setWindowNHQ({id : authorId, type : "author", slug : username}))} to={`/author/${username}`} >Visit Profile</Link>
      </div> 
      {/* <Row>
        <Text className="block textbold">Karma:</Text>
        <Text> 203</Text>
      </Row> */}
      {/* <Row>
        <Text className="textbold">User Since</Text>
        <Text>{": " + dateOnly}</Text>
      </Row> */}
    </Col>
  );

  const items = [
    {
      key: '1',
      type: 'item',
      label: <Link className={styles.anchorTag} onClick={()=> dispatch(setWindowNHQ({id : id, type : 'collection', slug : slug}))}  to={`/collection/${slug}`} ><Text onClick={handlelogin}>Open Collection</Text></Link>,
    },
    {
      key: '2',
      icon: false,
      label: <Text onClick={isLogin ? handleBookmark : handlelogin} >{isBookmark?.length !== 0 ? 'Edit Saved' : 'Save Collection'}</Text>,
    
      children: isLogin &&  [ 
        {
          key: '2-1',
          label: <Col span={24}>
          <Checkbox.Group style={{flexDirection: "column", display: 'flex'}} value={isBookmark} defaultValue={isBookmark} options={saveOptions} onChange={handleSave}  />
        </Col>,
        },
      ], 
    },

  ];

  return (
    <>
      <Card
      id={id}
        loading={loading}
        bodyStyle={{ padding: "0" }}
        className={styles.cardMain}
      >
        <Row className={styles.cardRow}>
          {/* Card Left Column  */}

          <Col
            xs={0}
            sm={3}
            md={2}
            lg={2}
            className={`center ${styles.likedislike}`}
            flex={1}
            style={{ gap: "15px", alignItems: "flex-start" }}
          >
            <Col
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
              }}
            >
              <Tooltip placement="left" overlayInnerStyle={{fontSize: "12px"}} title="Upvote" color={'blue'} key={"upvote"}>
              <CaretUpOutlined
              onClick={()=>isLogin ? (userInteractionProcessing ?   message.warning("Please wait for a moment..") : dispatch(handleLike(id))): handlelogin()}
              style={{ fontSize: "30px", color:  like ? "green" : "black" }}
                className="iconsize pointer"
              /></Tooltip>
              <Tooltip placement="left" overlayInnerStyle={{fontSize: "12px"}} title="Votes" color={'blue'} key={"votes"}>
              <Title style={{ margin: "auto" }} level={3}>
                {votes }
              </Title>
              </Tooltip>
              <Tooltip placement="left" overlayInnerStyle={{fontSize: "12px"}} title="Downvote" color={'blue'} key={"downvote"}>
              <CaretDownOutlined
              style={{ fontSize: "30px", color: dislike ? "red" : "black" }}
              onClick={()=>isLogin ? (!userInteractionProcessing ?  dispatch(handleDislike(id)) : message.warning("Please wait for a moment..")) : handlelogin()}
                className="iconsize pointer"
              /></Tooltip>
            </Col>
          </Col>
          {/* Card Center Column  */}

          <Col
            xs={14}
            sm={12}
            md={16}
            lg={16}
            className={styles.cardCenterCol}
            flex={4}
            style={{rowGap: "5px"}}
          >
            <Row className="titleRow">
              <Title
                onClick={() => {
                  setOpen(true);
                  (id !== sliceItemId) && dispatch(fetchPublicItems(id));
                }}
                className="pointer"
                style={{ margin: "2px 4px 2px 0px" }}
                level={4}
              >
                {title}
              </Title>
              {/* <BadgeIcon color={"white"} bgColor={"red"} label={"Sponsored"}/> */}
            </Row>
            {/* <Popover
              trigger={"hover"}
              placement="topLeft"
              title={popoverTitle}
              content={content}
            >
              <Title className={styles.creatorNameMiddle} level={5}>
                {creator}
              </Title>
            </Popover> */}
            <Paragraph
              className={styles.cardDescription}
              style={{ margin: "2px 4px 2px 0px" }}
              ellipsis={{ rows: 2, expandable: false }}
            >
              {parse(description ?? '')}
            </Paragraph>
            {/* <Text style={{ margin: "2px 0px 6px 0px" }} strong>
              {url}
            </Text> */}
            {/* <Row>
              <BadgeIcon color={"black"} bgColor={"orange"} label={type} />
              <BadgeIcon color={"black"} bgColor={"orange"} label={format} />
              <BadgeIcon color={"black"} bgColor={"orange"} label={level} />
            </Row> */}
            {/* <Row>
              <BadgeIcon color={"white"}  bgColor={"purple"} label={year} />
              <BadgeIcon color={"white"} bgColor={"purple"} label={language} />
            </Row> */}
            <Row>
              {!tags ? null : (
                <Col span={24}>
                  {tags.map((e: any) => (
                    <a onClick={()=> window.location.href = `/tag/${e?.slug}`}>
                    <BadgeIcon
                      key={e?.slug}
                      color={"#155ca2"}
                      bgColor={e?.color ?? "#edf5fd"}
                      label={e?.slug}
                    />
                    </a>
                  ))}
                </Col>
              )}
        
            </Row>
          </Col>

          {/* Card Right Column  */}

          <Col
            xs={10}
            sm={9}
            md={6}
            lg={6}
            className="cardRightCol"
            style={{ display: "flex", flexDirection: "column", justifyContent: "end" }}
            flex={3}
          >
            {/* Links  */}

            <Row className={styles.cardRightColTopIconsDiv}>
              <div className={styles.cardTopIcons}>
                <Tooltip overlayInnerStyle={{fontSize: "12px"}} title="Open Collection" color={'blue'} key={"viewFull"}>
                <Link style={{marginRight: "10px"}} className={styles.anchorTag} onClick={()=> dispatch(setWindowNHQ({id : id, type : 'collection', slug : slug}))} to={`/collection/${slug}`}>
                <Image
                preview={false}
                className={` ${styles.cardTopIcon}`} width={22} src={ViewIcon}/></Link>
                </Tooltip>
                <Tooltip overlayInnerStyle={{fontSize: "12px"}} title="Save" color={'blue'} key={"save"}>
                <Popover className={styles.triggerMenuPopover} onOpenChange={handlePopoverOutsideClick} open={openBookmark} trigger={'click'} placement="right" title={'Save in'} content={saveContent}>
                  {isBookmark?.length !== 0  ? 
                <Image
                preview={false}
                className={` ${styles.cardTopIcon}`}
                onClick={isLogin ? handleBookmark : handlelogin} width={20} src={SaveIcon}/>
                 :
                <Image
                preview={false}
                className={` ${styles.cardTopIcon}`}
                onClick={isLogin ? handleBookmark : handlelogin} width={20} src={SaveIconFilled}/>}
                </Popover> 
                </Tooltip>
              </div>
              <TriggerMenu onOpenChange={handleDropdownOutsideClick} setOpenDropdown={setOpenDropdown} open={openDropdown} label={"More"} items={items} />
            </Row>

            {/* Submitted By Text  */}

            <Col style={{marginTop: "40px"}} className={styles.likeDislikeIcons} >
                <div>
                  {!like ? 
                  <LikeOutlined onClick={()=>isLogin ? (!userInteractionProcessing ?  dispatch(handleLike(id)) : message.warning("Please wait for a moment..")) : handlelogin()} style={{ fontSize: "18px"}} />:
                  <LikeFilled onClick={()=>isLogin ? (!userInteractionProcessing ?  dispatch(handleLike(id)) : message.warning("Please wait for a moment..")) : handlelogin()} style={{fontSize: "18px", color: "green"}}  /> }
                  {!dislike ? 
                  <DislikeOutlined onClick={()=>isLogin ? (!userInteractionProcessing ?  dispatch(handleDislike(id)) : message.warning("Please wait for a moment..")) : handlelogin()} style={{ fontSize: "18px", marginLeft: "10px" }} />:
                  <DislikeFilled onClick={()=>isLogin ? (!userInteractionProcessing ?  dispatch(handleDislike(id)) : message.warning("Please wait for a moment..")) : handlelogin()} style={{ fontSize: "18px", color: "red", marginLeft: "10px" }} />}
                </div>
                <div>
                  <Text style={{fontWeight: '500'}} >{`${votes} Votes`}</Text>
                </div>
              </Col>

            <Col className={styles.textRight}>
              {/* <Text
                className="fontsmall"
                style={{
                  fontWeight: "500",
                  margin: "2px 0px 2px 0px",
                  display: "block",
                }}
              >
                submitted by
              </Text> */}

              <Popover
                trigger={"hover"}
                placement="topRight"
                title={popoverTitle}
                content={content}
              >
                <Row align={"middle"} justify={"end"}>
                  <Image
                    onClick={()=> { dispatch(setWindowNHQ({id : authorId, type : "author", slug : username})) ; navigate(`/author/${username}`)}}
                    className="pointer"
                    preview={false}
                    width={20}
                    height={20}
                    style={{
                      objectFit: "cover",
                      borderRadius: "50%",
                      display: "inline-block",
                    }}
                    src={profilepic}
                  ></Image>

                  <Title onClick={()=> { dispatch(setWindowNHQ({id : authorId, type : "author", slug : username})) ; navigate(`/author/${username}`)}} className={styles.creatorName} level={5}>
                    {creator}
                  </Title>
                </Row>
                {/* <Text
                  className="textbold fontsmall pointer"
                  style={{ margin: "0px 0px 0px 0px", display: "block" }}
                >
                  {'karma'}
                </Text> */}
              </Popover>
              <Text
                className="textbold fontsmall"
                style={{ fontWeight: "500", margin: "2px 0px 2px 0px" }}
              >
                posted on {dateOnly}
              </Text>
            </Col>

          </Col>
        </Row>
      </Card>

      {loader ? (
        <Spin
          indicator={antIcon}
          className={styles.spinner}
          spinning={true}
          fullscreen
        />
      ) : (
        <CardModal open={open} setOpen={setOpen}></CardModal>
      )}

      <LoginModal redirectUrl={currentUrl} open={loginModal} onCancel={onLoginCancel}/>
    </>
  );
};

export default CollectionsCard;
